import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { addHashtag, thunkRemoveHashtag } from '@/redux/actions';

const WS_HASHTAGS_BY_HTTP = {
	CREATE: 'hashtags/POST',
	DELETE: 'hashtags/:hashtagID/DELETE',
};

const HashtagSubscriptions = props => {
	const { socket, currentEventId, addHashtag, removeHashtag } = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribe = () => {
		socket.emit('event/:eventID/hashtags/SUBSCRIBE', { eventID: currentEventId });
	};

	const unsubscribe = () => {
		socket.emit('event/:eventID/hashtags/UNSUBSCRIBE', { eventID: currentEventId });
	};

	const listenForCreatedHashtag = () => {
		socket.on(WS_HASHTAGS_BY_HTTP.CREATE, payload => {
			const { data, err } = payload;
			if (err) displayMessage('Hashtag could not be created', err);
			else {
				addHashtag(data);
				displayMessage('Hashtag added');
			}
		});
	};

	const listenForDeletedHashtag = () => {
		socket.on(WS_HASHTAGS_BY_HTTP.DELETE, payload => {
			const { data, err } = payload;
			if (err) displayMessage('Hashtag could not be deleted', err);
			else {
				removeHashtag(data.id);
				displayMessage('Hashtag deleted');
			}
		});
	};

	const listeners = () => [listenForCreatedHashtag, listenForDeletedHashtag];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribe}
				unsub={unsubscribe}
				listeners={listeners()}
				routes={Object.values(WS_HASHTAGS_BY_HTTP)}
				from="HashtagSubscriptions"
			/>
			{React.cloneElement(props.children, propsToSend)}
		</>
	);
};

const msp = ({ ws, events }) => ({
	socket: ws.socket,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	addHashtag: hashtag => dispatch(addHashtag(hashtag)),
	removeHashtag: id => dispatch(thunkRemoveHashtag(id)),
});

export default connect(msp, mdp)(HashtagSubscriptions);
